import { Checkbox } from '@components/Checkbox'

import { CheckboxContainer } from './styles'
import { useTileContext } from '../Context'

export function TileCheckbox() {
  const { isChecked, isSelectEnabled, isSelectable } = useTileContext()

  return (
    <>
      {isSelectEnabled && isSelectable && (
        <CheckboxContainer>
          <Checkbox isChecked={isChecked} />
        </CheckboxContainer>
      )}
    </>
  )
}
